import { EnumMapper } from "@indietabletop/appkit";
import type { ProductType } from "../client";

export const ProductLabel = EnumMapper.from<ProductType>({
  DIGITAL: "Digital Book", // Legacy type, will be phased out.

  DIGITAL_BOOK: "Digital Book",
  DIGITAL_MODEL: "3D Printable",
});
